<template>
  <section class="gamerProfile-section">
    <Header />
    <div class="gamerProfile-top-container">
      <div class="gamerProfile-avatar-container">
        <img :src="user.picture" alt />
      </div>
      <div class="gamerProfile-gamer-container">
        <span style="color: black">{{ user.name }}</span>
        <div class="gamerProfile-gamer-level-container"></div>
      </div>
    </div>
    <div class="gamerProfile-row-container">
      <div class="gamerProfile-badges-container">
        <div class="gamerProfile-badge">
          <img src="https://www.geoguessr.com/images/auto/144/144/ce/0/plain/badge/43f5c4d3ab7698f5e83a213dab9969a1.png" />
        </div>
        <div class="gamerProfile-texts">
          textos
          <br />
          regras blablabla
        </div>
      </div>
      <div class="gamerProfile-badges-container" v-for="(badge, key) in 12" :key="key">
        <div class="gamerProfile-badge">
          <img src="https://www.geoguessr.com/_next/static/images/default-medium-5290c4f9f355a809e3070160529b4c71.png" />
        </div>
        <div class="gamerProfile-texts">
          textos
          <br />
          regras blablabla
        </div>
      </div>
    </div>
    <div class="gamerProfile-scores-container">
      <div class="gamerProfile-highscore-container">
        <span>Leaderboard</span>
        <div class="gamerProfile-highscore" v-for="(badge, key) in 10" :key="key">
          <div class="">
            Alessio Alessandro - 25.000 pts
            <br />
            3 days ago
          </div>
        </div>
      </div>
      <div class="gamerProfile-activities-container">
        <span>Activities</span>
        <div class="gamerProfile-activities" v-for="(badge, key) in 12" :key="key">
          <div class="">
            You played a challenge on World and got 21,544 points.
            <br />
            3 days ago
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import DefaultAvatar from '@/assets/img/personIcon.png';
import api from '@/services/api';

export default {
  name: 'GamerProfile',
  components: {
    Header,
  },
  data() {
    return { user: {} };
  },
  methods: {
    loadValues() {
      if (this.$store.state.user.id) {
        try {
          api
            .get(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`)
            .then((response) => {
              //console.log('User= ',response.data);
              if (response.data) {
                // console.log('Response Data =', response.data);
                this.user = {
                  key: response.data.user_id,
                  picture: response.data.image ? response.data.image : DefaultAvatar,
                  name: response.data.name ? response.data.name : 'No name on register',
                  company: response.data.company,
                  role: response.data.role,
                  email: response.data.email,
                  about_me: response.data.about_me,
                  firstLogin: response.data.first_login,
                  lastLogin: response.data.last_login,
                  other: response.data.other,
                };
                if (this.user.other) {
                  this.user.other = JSON.parse(this.user.other);
                  this.user.buyer = this.user.other.buyer ? this.user.other.buyer : false;
                  this.buyer = this.user.buyer;
                } else {
                  this.user.buyer = false;
                }
                this.oldUser = { ...this.user };
                // this.name = this.user.name;
                // this.picture = this.user.picture == DefaultAvatar ? null : this.user.picture;
                // this.company = this.user.company;
                // this.role = this.user.role;
              }
            })
            .catch((err) => console.error(err));
        } catch (error) {
          console.error(error);
        }
        this.createUser = false;
      } else {
        if (accessConfig.publicSignIn) {
          //Must create user
          this.createUser = true;
        } else {
          //Error
          this.createUser = false;
        }
      }
    },
  },
  beforeMount() {
    this.loadValues();
  },
};
</script>

<style lang="scss">
.gamerProfile-points-container {
  // background: red;
  width: 100%;
  height: 30%;
  margin: 40px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  color: black;
}
.gamerProfile-points-item {
  margin: 10px 40px;
  padding: 16px 24px;
  background: var(--userProfile-middleBgColor);
  box-shadow: 0px 0px 22px 0 rgba(0, 0, 0, 0.2);
  border-radius: var(--input-borderRadius);
  display: flex;
  flex-direction: column;
  align-items: center;
  .gamerProfile-points-display {
    font-size: 4rem;
  }
}
.gamerProfile-section {
  padding-top: 80px;
  background: whitesmoke;
  min-height: 100dvh;
  color: var(--userProfile-textColor);
}
.gamerProfile-top-container {
  position: relative;
  width: 100vw;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 0;
  .gamerProfile-avatar-container {
    position: relative;
    img {
      position: relative;
      object-fit: cover;
      object-position: center;
      background-color: transparent;
      width: 70%;
      width: 150px;
      height: 150px;
      border: 4px solid white;
      border-radius: 50%;
      margin: 14px 0;
    }
  }
  .gamerProfile-gamer-container {
    position: relative;
    height: 100px;
    width: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    font-size: 1.8rem;
  }
  .gamerProfile-gamer-level-container {
    width: 80%;
    max-width: 800px;
    height: 40px;
    background: teal;
    border-radius: 20px;
    margin-top: 20px;
  }
}
.gamerProfile-row-container,
.gamerProfile-scores-container {
  position: relative;
  background: #fcfaf900;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  padding-bottom: 20px;
}
.gamerProfile-badges-container {
  position: relative;
  margin: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  .gamerProfile-badge {
    position: relative;
    height: 100px;
    width: 100px;
    background: white;
    border-radius: 50%;
    margin-bottom: 10px;
    img {
      position: relative;
      object-fit: cover;
      object-position: center;
      background-color: transparent;
      width: 70%;
      width: 100px;
      height: 100px;
      border: 4px solid white;
      border-radius: 50%;
    }
  }
  .gamerProfile-texts {
    text-align: center;
    color: black;
  }
}
.gamerProfile-highscore-wrapper,
.gamerProfile-activities-wrapper {
  background: var(--userProfile-middleBgColor);
  box-shadow: 0px 0px 22px 0 rgba(0, 0, 0, 0.2);
  border-radius: var(--input-borderRadius);
  padding: 30px;
  margin: 10px;
  min-width: 400px;
  @include media('<=tablet') {
    min-width: 400px;
    width: 52%;
    padding: 30px 10px;
  }
  @include media('<=phone') {
    min-width: unset;
    width: 100%;
    padding: 30px 4px;
  }
}
.gamerProfile-highscore-container,
.gamerProfile-activities-container {
  position: relative;
  max-height: 460px;
  display: flex;
  // flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  color: var(--text-color);
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: var(--card-scrollbarBorderRadius);
  }
  &::-webkit-scrollbar-thumb {
    background-color: #40404040 !important;
    border-radius: 4px;
    background-image: none !important;
  }
}
.gamerProfile-highscore-container {
  .gamerProfile-highscore {
    position: relative;
    display: flex;
    width: 100%;
    // background: red;
    padding: 10px;
    .gamerProfile-highscore-entry {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 1.23rem;
    }
  }
}
.gamerProfile-activities-title,
.gamerProfile-highscore-title {
  font-size: 2.7rem;
  text-align: center;
  display: flex;
  justify-content: center;
  padding: 0 10px 20px 10px;
}
.gamerProfile-activities-container {
  .gamerProfile-activities {
    position: relative;
    display: flex;
    width: 100%;
    padding: 10px;
  }

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: var(--card-scrollbarBorderRadius);
  }
  &::-webkit-scrollbar-thumb {
    background-color: #40404040 !important;
    border-radius: 4px;
    background-image: none !important;
  }
}
</style>
